/* @flow */

import { compose, intersection } from 'ramda';
import * as React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './PreferenceLanguageSection.style';

import messages from 'src/shared/app/preference/l10n/preferenceLanguageL10n';
import {
  getLocaleLabel,
  supportedLocales,
} from 'src/shared/app/locale/settings/localeSettings';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  eventLocales: Array<string>,
  handleChange: (locale: string) => void,
  // Self passed
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const PreferenceLanguageSectionDumb = ({
  eventLocales,
  handleChange,
  intl,
}: Props): React.Node => {
  const availableLocales = intersection(supportedLocales, eventLocales);

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | State
   |----------------------------------------------------------------------------
   */

  const [locale, setLocale] = React.useState(intl.locale);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onChange = ({ target }: Event) => {
    if (target instanceof HTMLSelectElement) {
      const { value } = target;

      setLocale(value);

      if (handleChange) {
        handleChange(value);
      }
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */
  if (availableLocales.length < 2) return null;

  const options = availableLocales.map((item) => (
    <option value={item} key={item}>
      {getLocaleLabel(item)}
    </option>
  ));

  return (
    <div>
      <p className={classes.label}>{intl.formatMessage(messages.label)}</p>
      <div className={classes.inputCtn}>
        <select className={classes.select} value={locale} onChange={onChange}>
          {options}
        </select>
        <span className={classes.icon}>{'>'}</span>
      </div>
    </div>
  );
};

export default compose(React.memo, injectIntl)(PreferenceLanguageSectionDumb);
